import React from 'react';
import './NewAccordanceForm.scss';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AccordanceType } from '../../../../../models/AccordanceType';
import { AccordanceState } from '../../../../../models/AccordanceState';
import { CommonInputs } from './CommonInputs';
import NewAccordanceFormButtons from './NewAccordanceFormButtons';
import useFormState from '../../../../../hooks/useFormState';
import Project from '../../../../../models/Project';
import { LoadingModal } from '../../../../Util/Modals/LoadingModal/LoadingModal';
import { ReactComponent as IconAlertExclamation } from '../../../../../assets/icons/u_alert-exclamacion.svg';

type Props = {
  close: Function;
  accordanceFormType: AccordanceType;
  displayGenericErrorsMessage: Function;
  setAlertConfig?: Function;
  editAccordanceData?: any;
  review?: any;
  accordanceState?: number;
  currentUserCanApprove?: boolean;
  accordanceCreateRevision?: boolean;
  criticalDataForm?: {};
  closeModalEditReviewer?: any;
  isSuggesttion?: boolean;
  saveChangesHandlerRef?: React.MutableRefObject<(() => void | Promise<void>) | null>;
  submitDraftToApproval?: Function;
  onDirtyChange?: (value: boolean) => void;
};

const NewAccordanceForm = (props: Props) => {
  const currentProject = useSelector<any, Project>(state => state.currentProject);
  const { t } = useTranslation();
  const {
    accordanceState,
    currentUserCanApprove,
    editAccordanceData,
    review,
    closeModalEditReviewer,
    accordanceCreateRevision,
    saveChangesHandlerRef,
    submitDraftToApproval,
    onDirtyChange,
  } = props;

  const {
    accordanceFormType,
    revisionDate,
    setFormErrors,
    formErrors,
    setRevisionDate,
    expirationDate,
    setExpirationDate,
    setSemesterOption,
    semesterOption,
    criticalIssueList,
    criticalIssue,
    handleCriticalIssueChange,
    category,
    possibleActionsList,
    possibleAction,
    handlePossibleActionChange,
    handleExpirationDate,
    responsible,
    handleIemSelected,
    accordanceFiles,
    setAccordanceFiles,
    editAccordanceInfo,
    description,
    criticalIssueDescription,
    setCriticalIssueDescription,
    setDescription,
    submit,
    disableDraftButton,
    disableSendToApprovalButton,
    submitting,
    submitAccordanceDraft,
    supervisionActionList,
    handleSupervisionActionChange,
    supervisionAction,
    accordanceDate,
    handleAccordanceDate,
    setMultipleAccordances,
    definedAgreement,
    linkedProductsAccordance,
    rootCauseOfCritical,
    rootCause,
    handleDefinedAgreementChange,
    handleLinkedProduct,
    handleRootCauseOfCritical,
    handleRootCause,
    accordanceType,
    rootCauseCategories,
    rootCauseForm,
    productForm,
    validateTextareaCritical,
    validateTextareaDescription,
    substantialTypeChange,
    handleSubstantialTypeChange,
    PMBLink,
    handlePMBLink,
    substantialChangeTypeOptions,
    loading,
    setLoading,
    isFormDirty,
    isRequiredChangeRevisionDate
  } = useFormState({ ...props, currentProject });

  React.useEffect(() => {
    onDirtyChange?.(isFormDirty);
  }, [isFormDirty, onDirtyChange]);

  if (saveChangesHandlerRef) {
    saveChangesHandlerRef.current =
      editAccordanceData && editAccordanceData.accordanceState === AccordanceState.PENDING
        ? () => submit(false)
        : submitAccordanceDraft;
  }

  return (
    <div className="new-accordance-form-container">
      <section className='common-inputs-container'>
        <CommonInputs
          criticalIssueList={criticalIssueList}
          criticalIssue={criticalIssue}
          handleCriticalIssueChange={handleCriticalIssueChange}
          formErrors={formErrors}
          category={category}
          possibleActionsList={possibleActionsList}
          possibleAction={possibleAction}
          handlePossibleActionChange={handlePossibleActionChange}
          expirationDate={expirationDate}
          handleExpirationDate={handleExpirationDate}
          responsible={responsible}
          handleIemSelected={handleIemSelected}
          projectId={currentProject.id}
          filesList={accordanceFiles}
          addFileToList={file => {
            setAccordanceFiles([...accordanceFiles, file]);
          }}
          removeFileFromList={file => {
            setAccordanceFiles(accordanceFiles.filter(item => item.url !== file.url));
          }}
          editAccordanceData={editAccordanceInfo}
          closeParentModal={props.close}
          accordanceType={accordanceFormType}
          description={description}
          criticalIssueDescription={criticalIssueDescription}
          handleCriticalIssueDescription={desc => {
            setCriticalIssueDescription(desc);
          }}
          handleDescription={desc => {
            setDescription(desc);
          }}
          revisionDate={revisionDate}
          accordanceState={accordanceState}
          supervisionActionList={supervisionActionList}
          handleSupervisionActionChange={handleSupervisionActionChange}
          supervisionAction={supervisionAction}
          setFiles={setAccordanceFiles}
          setFormErrors={setFormErrors}
          setRevisionDate={setRevisionDate}
          setExpirationDate={setExpirationDate}
          setSemesterOption={setSemesterOption}
          semesterOption={semesterOption}
          accordanceFormType={accordanceFormType}
          accordanceDate={accordanceDate}
          handleAccordanceDate={handleAccordanceDate}
          definedAgreement={definedAgreement}
          linkedProduct={linkedProductsAccordance}
          rootCauseOfCritical={rootCauseOfCritical}
          rootCause={rootCause}
          handleDefinedAgreementChange={handleDefinedAgreementChange}
          handleLinkedProduct={handleLinkedProduct}
          handleRootCauseOfCritical={handleRootCauseOfCritical}
          handleRootCause={handleRootCause}
          accordanceDefinitionForm={accordanceType}
          rootCauseCategoriesForm={rootCauseCategories}
          rootCauseForm={rootCauseForm}
          productForm={productForm}
          validateTextareaCritical={validateTextareaCritical}
          validateTextareaDescription={validateTextareaDescription}
          issuggestedAgreement={editAccordanceData?.issuggestedAgreement}
          isSubstantialAgreement={definedAgreement?.id === AccordanceType.Substantial}
          substantialTypeChange={substantialTypeChange}
          handleSubstantialTypeChange={handleSubstantialTypeChange}
          PMBLink={PMBLink}
          handlePMBLink={handlePMBLink}
          substantialChangeTypeOptions={substantialChangeTypeOptions}
          isRequiredChangeRevisionDate={isRequiredChangeRevisionDate}
          setAlertConfig={props.setAlertConfig}
        />
      </section>

      {/* {(review || editAccordanceData || accordanceCreateRevision || definedAgreement?.id === AccordanceType.Substantial) ? null */}
      {(review || editAccordanceData || accordanceCreateRevision) ? null : (
        <section>
          <div className="container-multi-accordances-button">
            <button className="multi-accordances-link" onClick={setMultipleAccordances}>
              <div className="multi-accordances-buttton"></div>
              {t('save_and_add_to_bundle')}
            </button>
          </div>
        </section>
      )}

      {
        isRequiredChangeRevisionDate && (
          <div className="accordance-detail-draft-warning --update-revision-date">
            <IconAlertExclamation />
            <p className="accordance-detail-draft-warning-text">{t('update_revision_date_alert')}</p>
          </div>
        )
      }

      <section>
        <NewAccordanceFormButtons
          submit={() => submit(false)}
          submitting={submitting}
          disableDraftSubmit={disableDraftButton || isRequiredChangeRevisionDate}
          disableSendToApprovalButton={disableSendToApprovalButton}
          accordanceType={accordanceFormType}
          saveAsDraft={submitAccordanceDraft}
          currentUserCanApprove={currentUserCanApprove}
          cancel={props.close}
          editAccordanceData={editAccordanceData}
          publish={() => submit(true)}
          closeModalEditReviewer={closeModalEditReviewer}
          accordanceCreateRevision={accordanceCreateRevision}
          submitDraftToApproval={submitDraftToApproval!}
        />
      </section>
      {loading &&
        <LoadingModal
          isOpen={loading}
          closeModal={() => setLoading(false)}
          title={t('loading_message')}
        />}
    </div>
  );
};

export default NewAccordanceForm;
